import axios from "axios";
import createPublicApiInstance from '../api';

export function getSpecialties() {
	return axios.get(`${process.env.REACT_APP_DANSUAPI}/private/especialidad/`);
}

export function searchProviderBySpeciality(id) {
	return axios.get(`${process.env.REACT_APP_DANSUAPI}/private/prestador/?especialidad_id=${id}`);
}

export async function searchProvider(id) {
	try {
		const response = await axios.get(`${process.env.REACT_APP_DANSUAPI}/private/agenda/?especialidad_id=${id}`);
		return response.data
	} catch (error) {
		return { error }
	}
}

export async function getProvider() {
	try {
		const response = await axios.get(`${process.env.REACT_APP_DANSUAPI}/private/prestador/`);
		return response.data
	} catch (error) {
		return { error }
	}
}

export async function getProfesional() {
	try {
		const response = await axios.get(`${process.env.REACT_APP_DANSUAPI}/private/profesional/`);
		return response.data
	} catch (error) {
		return { error }
	}
}

export async function getProfesionalByProvider(id) {
	try {
		const response = await axios.get(`${process.env.REACT_APP_DANSUAPI}/private/profesional/search?prestador_id=${id}`);
		return response.data
	} catch (error) {
		return { error }
	}
}

export async function getPlansService(id) {
	try {
		const response = await axios.get(`${process.env.REACT_APP_DANSUAPI}/private/afiliado/${id}/plans`);
		return response.data
	} catch (error) {
		return { error }
	}
}

export function getCountries() {
	//return axios.get(`${process.env.REACT_APP_DANSUAPI}/private/country`);
	const apiInstance = createPublicApiInstance();
	if (!apiInstance) {
		throw new Error('API instance is not available');
	}
	return apiInstance.get(`/dol-to-sisad-direccion/country`);
}

export function getStates(id_country) {
	//return axios.get(`${process.env.REACT_APP_DANSUAPI}/private/states/search?id=${id_country}`);
	const apiInstance = createPublicApiInstance();
	if (!apiInstance) {
		throw new Error('API instance is not available');
	}
	return apiInstance.get(`/dol-to-sisad-direccion/state/${id_country}`);

}

export function getDepartament(id_state) {
	// return axios.get(`${process.env.REACT_APP_DANSUAPI}/private/departamentos/search?id=${id_state}`);
	const apiInstance = createPublicApiInstance();
	if (!apiInstance) {
		throw new Error('API instance is not available');
	}
	return apiInstance.get(`/dol-to-sisad-direccion/department/${id_state}`);
}

export function getLocation(cp) {
	return axios.get(`${process.env.REACT_APP_DANSUAPI}/private/localidad/search?codigo_postal=${cp}`);
}

export async function getTypeDocuments() {
	try {
		const response = await axios.get(`${process.env.REACT_APP_DANSUAPI}/private/tipo_documento`);
		return response.data
	} catch (error) {
		return { error }
	}
}